import React, { Fragment, useMemo } from "react";

import { DeploymentService } from "@packages/client";

import ViewPortOnly from "src/organization/pages/project/environment/metrics/components/ViewPortOnly";
import { getDistanceToPreload } from "src/organization/pages/project/environment/metrics/utils/helper";

import * as S from "./Grid.styles";
import GridService, { GridServiceProps } from "./GridService";

type ServiceGroupProps = {
  services: DeploymentService[];
} & Omit<GridServiceProps, "service">;

const ServiceGroup = (props: ServiceGroupProps) => {
  const { services, ...rest } = props;
  const index = services?.[0]?.["kind"];
  const section = index == "webapp" ? "Application" : index;

  const sortedServices = useMemo(
    () => services.sort((a, b) => a.name.localeCompare(b.name)),
    [services]
  );
  const { rootMargin } = getDistanceToPreload(rest.selectedTimeframe);

  return (
    <Fragment>
      <S.SectionHeader>{`${section}s`}</S.SectionHeader>
      {sortedServices.map(service => {
        return (
          <ViewPortOnly key={service.name} option={{ rootMargin }}>
            <GridService service={service} {...rest} />
          </ViewPortOnly>
        );
      })}
    </Fragment>
  );
};

export default ServiceGroup;
